import {
  initialState,
  Actions,
  State,
  NEW_FACTURACION,
  NEW_FACTURACION_SUCCESS,
  NEW_FACTURACION_ERROR,
  RESET_NEW_FACTURACION,
} from "../../types/facturacion/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_FACTURACION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_FACTURACION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_FACTURACION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_FACTURACION:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
